module.exports = __webpack_public_path__ + "img/outlander7.a183bb64.jpeg";